export const getThumbUrl = (url, size = 256, updatedAt = '') => {
  if (url) {
    const thumbUrl = url.replace(/\.(.{3})$/, `_thumb${size}.$1`);
    return `${thumbUrl}?${updatedAt}`;
  }
  return null;
};
